import { createIcon } from './icon';

export const CheckmarkIcon = createIcon(
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3.5 8.5L6.5 11.5L12.5 4.5" />
  </svg>,
  'CheckmarkIcon'
);
